import React from 'react'
import ReactDOM from 'react-dom'

import MenuItemChat from '../../menu-items/chat/menu-item-chat-new'
import Chat from "../../../../core/model2/chat/chat/chat"
import NavigationMenu_TopHeader from "../../components/top-header/top-header"
import NavigationMenuSection from "../../menu-items/section/section"
import NavigationSection from "../../../../core/model2/navigation/navigation-section"
import {NavigationSectionType} from "../../../../core/model2/navigation/@const"
import {
    EVENT_BUS_CHAT_COUNTER_UPDATE,
    EVENT_BUS_CHAT_DELETED,
    EVENT_BUS_CHAT_NEW,
    EVENT_BUS_SESSION_CHATS_CHANGE
} from "../../../../core/model2/chat/chat/const"
import MainMenu_ChatsLoading from "./components/loading"
import MainMenu_ChatsNotFound from "./components/no-chats"
import MainMenu_ChatsAdd from "./components/add-chat"
import VScroll from "../../../../core/gd-components/scrolling/custom-v-scroll/v-scroll"
import sessionInitChats from "../../../../core/gd-session/chat/init-chats"
import ErrorBoundary from '../../../../core/error-boundary'
import MenuTopHeader_SearchActive from "../../components/top-header/search/search";
import {MenuSpaceSearch} from "../../components/search/menu-space-search";
import {SpaceChats} from "../../../../core/model2/space/system/chats";
import MenuSearch_NoResults from "../../../search/search-results/no-results";
import MenuTopHeader_SearchButton from "../../components/top-header/search/search-button";

type Props = {

    refScroll   : React.RefObject<VScroll>
    // section     : NavigationSection

    noAnimation : boolean
    showTitle?  : boolean
    showAvatar? : boolean
    showSearch? : boolean
    customChats?: boolean
    chats       : Chat[] | null
}


export default class MainMenu_Chats extends React.Component<Props> {

    private animationDelay      : any
    public navigationSection    : NavigationSection = gd.navigationStructure.get(NavigationSectionType.CHATS)
    public spaceSearch          : MenuSpaceSearch

    // Default values for props
    public static defaultProps = {
        showTitle  : true,
        showAvatar : true,
        showSearch : true,
        customChats: false,
        chats      : null
    }

    constructor(props: Props) {
        super(props)

        this.spaceSearch = new MenuSpaceSearch(new SpaceChats(), this.reRender)
    }

    componentDidMount() {
        this.animationDelay = _.delay(()=>{
            const dom = ReactDOM.findDOMNode(this)
            gd.utils.Dom.addClass(dom, 'anim-show')
        }, 25)

        if (!gd.session.chatsLoaded) {
            sessionInitChats().then(()=>{this.reRender()})
        }

        gd.bus.subscribe(EVENT_BUS_SESSION_CHATS_CHANGE, this, this.reRender)
        gd.bus.subscribe(EVENT_BUS_CHAT_NEW, this, this.reRender)
        gd.bus.subscribe(EVENT_BUS_CHAT_DELETED, this, this.reRender)
        gd.bus.subscribe(EVENT_BUS_CHAT_COUNTER_UPDATE, this, this.reRender)
        gd.bus.subscribe('chat-room:update', this, this.onChatRoomUpdate)
        gd.bus.subscribe('chat-room:update-header', this, this.onChatRoomUpdate)
        gd.bus.subscribe('menu-chat-list:update', this, this.reRender)
    }

    componentWillUnmount() {
        clearTimeout(this.animationDelay)
        gd.bus.unsubscribe(this)
    }

    onChatRoomUpdate = (data: any) => {
        if (data) {
            const chat = gd.session.chats.get(data.id)
            if (!chat) return

            chat.name = data.name
            this.reRender()
        }
    }

    onBackClick = () => {
        gd.bus.triggerEvent('section-change','home');
    }

    renderChatsList() {
        gd.session.chats.sortModels()

        const chats : Chat[] = this.spaceSearch.isActive ? gd.session.chats.search(this.spaceSearch.searchValue) : gd.session.chats.models

        if (_.isEmpty(chats)) {
            return <MenuSearch_NoResults message="No chats found in this space."/>
        }

        return (
            <>
                {_.map(chats, (chat:Chat)=> {

                    return (
                        <ErrorBoundary key={chat.id}>
                            <MenuItemChat key={chat.id}
                                          navigationSection={this.navigationSection}
                                          chatId={chat.id}
                                          chat={chat}
                                          showAvatar={this.props.showAvatar}
                                          showPin={true}
                                          customChats={this.props.customChats}/>
                        </ErrorBoundary>
                    )
                })}
                <MainMenu_ChatsAdd/>
            </>
        )
    }

    reRender = ()=> {
        this.forceUpdate()
    }

    render() {
        const classes = Classes('main-menu-container ui5-menu menu-chats',{
            'animation': gd.layout.shouldAnimateMenu && !this.props.noAnimation
        });

        const rightButtonsClasses = Classes("flex-row-right-center", {
            "w-100-percent": this.spaceSearch.isActive
        })

        const isLoaded = !!gd.session.chatsLoaded

        return (
            <div className={classes}>
                {!this.spaceSearch.isActive &&
                    <NavigationMenu_TopHeader space={gd.spaces.chats}>
                        <div className={rightButtonsClasses}>
                            <MenuTopHeader_SearchButton className="m-r-15" spaceSearch={this.spaceSearch}/>
                        </div>
                    </NavigationMenu_TopHeader>
                }

                {this.spaceSearch.isActive &&
                    <div className="top-header flex-row-between-center">
                        <MenuTopHeader_SearchActive spaceSearch={this.spaceSearch}/>
                    </div>
                }

                <VScroll ref={this.props.refScroll} className="main-menu-scroll" mutationObserverEnabled={true}>
                    {!isLoaded && <MainMenu_ChatsLoading/>}

                    {isLoaded && gd.session.chats.isEmpty && <MainMenu_ChatsNotFound/>}

                    {isLoaded && !gd.session.chats.isEmpty &&
                        <NavigationMenuSection>
                            {this.renderChatsList()}
                        </NavigationMenuSection>
                    }
                </VScroll>
            </div>
        )
    }
}
